export default __webpack_public_path__ + "static/media/kolkata3.72e885c2.jpg";